import * as Yup from 'yup';

const PrePaymentValidation = Yup.object().shape({
  amount: Yup.number().required('Amount is required').min(1, 'Amount must be greater than 0'),
});

export { PrePaymentValidation };
